import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import Columns from '~/components/blocks/core/Columns';

const ColumnsBlock = ({
    columns = [],
    attrs: { anchor, verticalAlignment, className }
}) => <Columns {...{ columns, anchor, verticalAlignment, className }} />;

ColumnsBlock.propTypes = {
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            order: PropTypes.number.isRequired,
            attributes: PropTypes.shape({
                anchor: PropTypes.string,
                width: PropTypes.string,
                className: PropTypes.string
            }),
            blocks: PropTypes.arrayOf(
                PropTypes.shape({
                    name: PropTypes.string.isRequired
                })
            )
        })
    ),
    attrs: PropTypes.shape({
        anchor: PropTypes.string,
        verticalAlignment: PropTypes.string,
        className: PropTypes.string
    }).isRequired
};

export default ColumnsBlock;

export const fragment = graphql`
    fragment ColumnsBlockFragment on WpCoreColumnsBlock {
        name
        attrs: attributes {
            ... on WpCoreColumnsBlockAttributes {
                anchor
                className
                verticalAlignment
            }
        }
        columns: innerBlocks {
            ... on WpCoreColumnBlock {
                order
                attributes {
                    ... on WpCoreColumnBlockAttributes {
                        anchor
                        width
                        className
                    }
                }
                blocks: innerBlocks {
                    ...ColumnsBlockListFragment
                }
            }
        }
    }
`;

export const exampleData = [
    {
        variant: '50/50 Columns',
        description:
            'Blocks that can be used within a column: Paragraph, Image, Heading, List, Spacer, Html, Freeform.',
        props: {
            name: 'core/columns',
            attrs: {
                verticalAlignment: '',
                isStackedOnMobile: true
            },
            columns: [
                {
                    order: 0,
                    attributes: {
                        width: null,
                        anchor: '0-50/50'
                    },
                    blocks: [
                        {
                            name: 'core/paragraph',
                            order: 0,
                            attrs: {
                                content:
                                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.'
                            }
                        }
                    ]
                },
                {
                    order: 1,
                    attributes: {
                        width: null,
                        anchor: '1-50/50'
                    },
                    blocks: [
                        {
                            name: 'core/paragraph',
                            order: 0,
                            attrs: {
                                content:
                                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.'
                            }
                        }
                    ]
                }
            ]
        }
    },
    {
        variant: '33/66 Columns Vertically Centered',
        props: {
            name: 'core/columns',
            attrs: {
                verticalAlignment: 'center',
                isStackedOnMobile: true
            },
            columns: [
                {
                    order: 0,
                    attributes: {
                        width: '33.33%',
                        anchor: '0-33/66'
                    },
                    blocks: [
                        {
                            name: 'core/paragraph',
                            order: 0,
                            attrs: {
                                content:
                                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.'
                            }
                        }
                    ]
                },
                {
                    order: 1,
                    attributes: {
                        width: '66.66%',
                        anchor: '1-33/66'
                    },
                    blocks: [
                        {
                            name: 'core/paragraph',
                            order: 0,
                            attrs: {
                                content:
                                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.'
                            }
                        }
                    ]
                }
            ]
        }
    }
];
